import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import EmptyState from "@/components/EmptyState";
import { Heart } from "lucide-react";

export default function FundraisersListPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/fundraisers").then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="z-container" style={{ textAlign: "center" }}><span className="z-loader z-loader-dark" /></div>;

  return (
    <div className="z-container" data-testid="fundraisers-page">
      <h1 className="z-page-title">Cagnottes</h1>
      <p className="z-page-sub">Soutenez les projets de la communauté — don anonyme possible.</p>

      {items.length === 0 ? (
        <EmptyState icon={<Heart size={28} />} title="Aucune cagnotte pour l'instant" message="Revenez bientôt." testId="fundraisers-empty" />
      ) : (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(260px,1fr))", gap: 18 }}>
          {items.map((f) => {
            const pct = f.goal > 0 ? Math.min(100, Math.round((f.raised / f.goal) * 100)) : 0;
            return (
              <Link key={f.id} to={`/fundraiser/${f.id}`} className="z-event-card" data-testid={`fundraiser-${f.id}`}>
                {f.image_url ? (
                  <img src={f.image_url} alt="" className="z-event-card-img" />
                ) : (
                  <div className="z-event-card-img" style={{ background: "linear-gradient(135deg,#DA7101,#01696F)" }} />
                )}
                <div className="z-event-card-body">
                  <h3 className="z-event-card-title">{f.title}</h3>
                  <p className="z-event-card-meta">{f.organizer_name}</p>
                  <div className="z-progress" style={{ margin: "10px 0 6px" }}>
                    <div className="z-progress-fill" style={{ width: `${pct}%` }} />
                  </div>
                  <div style={{ fontSize: 13, color: "var(--z-text)", fontWeight: 600 }}>
                    {f.raised.toFixed(0)} € <span style={{ color: "var(--z-muted)", fontWeight: 400 }}>/ {f.goal.toFixed(0)} €</span>
                  </div>
                  <div style={{ fontSize: 12, color: "var(--z-muted)" }}>{f.contributors_count} contributeur(s)</div>
                </div>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
